import Image from 'next/image';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ArrowForward } from '@mui/icons-material';
import { getGenericTrackingData } from '@finanzcheck/one-segment';

import { PartnerBanks } from 'components/PartnerBanks/PartnerBanks';

import { ANDROID, IOS, getOsName } from 'lib/router/route-helper';
import { trackButtonClick } from 'lib/tracking/track';
import { TrackingEvent } from 'lib/tracking/events';
import { USER_ID_COOKIE_NAME } from 'lib/helpers/optimizely/getUserId';
import { getCookie } from 'lib/cookies/cookieHelper';

import AppImage from 'public/assets/visuals/app-image.png';
import MobileStore from 'public/assets/visuals/app-play-store.svg';

const AppDownloadButton = styled(Button)(({ theme }) => ({
  margin: `${theme.spacing(1)}`,
}));

const AppImageBox = styled(Box)(({ theme }) => ({
  marginTop: `${theme.spacing(2)}`,
  background: `linear-gradient(180deg, ${theme.palette.common.white} 0%, ${theme.palette.secondary[50]} 100%)`,
  width: `calc(100% + ${theme.spacing(2)})`,
}));

// Note: This only fits the SEA stage headline
// You need to override this for other stages
const Headline = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 26,
  width: '100%',
  marginBottom: 0,
  [theme.breakpoints.up('md')]: {
    lineHeight: '64px',
    fontSize: 48,
    fontWeight: 700,
    width: '90%',
  },
}));

// Size may not be smaller than 14 on desktop
// due to legal reasons
// We have a cease and desist on that
// If in doubt, talk to legal dept.
export const TrustText = styled(Typography)(({ theme }) => ({
  fontSize: '8px',
  color: theme.palette.text.tertiary,
  wordBreak: 'break-word',
  lineHeight: '13px',
  margin: `${theme.spacing(1)} 0`,
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
    color: theme.palette.text.primary,
    lineHeight: '20px',
  },
  '& a': {
    fontWeight: 500,
    color: theme.palette.primary.main,
    '&:hover': {
      opacity: 0.75,
    },
  },
}));

export const AppDownloadSection = () => {
  const reDirectToCorrectStore = () => {
    const osName = getOsName();
    trackButtonClick(TrackingEvent.REDIRECT_TO_APP, {
      device: osName,
      ...getGenericTrackingData(),
    });
    if (osName === IOS || osName === ANDROID) {
      window.location.href = `https://app.adjust.com/ahuyru9?campaign=test_2024-06-18&label=${getCookie(
        USER_ID_COOKIE_NAME,
      )}`;
    }
  };

  return (
    <>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        sx={{
          mt: (theme) => theme.spacing(2),
        }}
      >
        <Image src={MobileStore} alt="mobile_store" style={{ width: '100%' }} />
        <AppDownloadButton
          data-test-id="appdownload-cta"
          variant="contained"
          fullWidth
          color="primary"
          type="button"
          onClick={reDirectToCorrectStore}
          endIcon={<ArrowForward />}
        >
          Jetzt die App herunterladen
        </AppDownloadButton>
        <AppImageBox>
          <Image
            src={AppImage}
            alt="app_image"
            style={{ width: '100%', height: '100%' }}
          />
        </AppImageBox>
        <Box
          style={{ alignSelf: 'flex-start' }}
          sx={{
            mt: (theme) => theme.spacing(1),
          }}
        >
          <TrustText>
            &#42;Weitere Informationen sowie die Garantie-Bedingungen finden Sie{' '}
            <a href="https://www.smava.de/kredit/guenstiger">hier</a>
          </TrustText>
        </Box>
        <PartnerBanks />
      </Box>
      <Headline variant="h1">
        Persönliche Angebote in 3 Minuten erhalten
      </Headline>
    </>
  );
};
